import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  isLoadingOfflineTime: false,
  isLogLoading: false,
  offlineTimeTableData: {
    head: [],
    body: []
  },
  logTableData: {
    head: [],
    body: []
  },
  CsvData: []
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_OFFLINETIME:
      var data = []
      if (typeof action.data == "number") {
        data = state.offlineTimeTableData.body.filter(item => item[5].id != action.data).map((i, index) => {
          return i
        })
      } else {
        data = action.data.map(i => {
          return [i.username, i.taskDescription, i.taskDate, i.fromTime, i.toTime, { id: i.id }]
        })
      }
      return {
        ...state,
        offlineTimeTableData: {
          head: [
            { label: "Employee Name", align: "left", isFilter: true, filterVal: null, index: 0 },
            { label: "Description", align: "left" },
            { label: "Date", align: "left", isFilter: true, filterVal: { startDate: null, endDate: new Date(""), key: 'selection' }, isDateSelection: true, index: 2 },
            { label: "From Time", align: "left" },
            { label: "To Time", align: "left" },
            { label: "Action", align: "right" },],
          body: data
        },
      }
    case types.FAIL_OFFLINETIME:
      return {
        ...state,
        offlineTimeTableData: {
          head: [],
          body: []
        },
      }

    case types.LOADING_OFFLINETIME:
      return {
        ...state,
        isLoadingOfflineTime: action.data
      }
    case types.GET_OFFLINETIME_LOG:
      var data = action.data.map(i => {
        return [i.username, i.taskDescription, i.taskDate, i.fromTime, i.toTime, i.actionBy, { status: i.status }]
      })
      return {
        ...state,
        logTableData: {
          head: [
            { label: "Employee Name", align: "left", isFilter: true, filterVal: null,index: 0  },
            { label: "Description", align: "left", },
            { label: "Date", align: "left", isFilter: true, filterVal: { startDate: null, endDate: new Date(""), key: 'selection' }, isDateSelection: true,index: 2  },
            { label: "From Time", align: "left" },
            { label: "To Time", align: "left" },
            { label: "Action By", align: "left", isFilter: true, filterVal: null ,index: 5},
            { label: "Status", align: "center", isFilter: true, filterVal: null ,index: 6},],
          body: data
        },
      }
    case types.FAIL_OFFLINETIME_LOG:
      return {
        ...state,
        logTableData: {
          head: [],
          body: []
        }
      }
    case types.LOADING_OFFLINETIME_LOG:
      return {
        ...state,
        isLogLoading: action.data
      }
    default:
      return state
  }

}
export default reducer
